import * as Flags from 'country-flag-icons/react/3x2';
import TeamIcon from '../images/team_icon.svg';
import { getTeamCountryCode } from '../helpers/teamCountryCodes';



const TeamLogo = ({ team, className, alt, style, countryCode: countryCodeProp }) => {

    // Country-code mode: render a plain country flag from an explicit ISO code
    // (used in place of react-country-flag). Renders nothing when the code is
    // unknown, rather than a broken image.
    if (countryCodeProp !== undefined) {
        const Flag = countryCodeProp ? Flags[countryCodeProp.toUpperCase().replace('-', '_')] : null;
        return Flag ? <Flag title={alt} className={className} style={style} aria-label={alt} /> : null;
    }

    const countryCode = getTeamCountryCode(team?.name);
    const Flag = countryCode ? Flags[countryCode.replace('-', '_')] : null;
    // image is provided but the name resolves to a known country (covers
    // the case where `/fixtures` doesn't set `is_national_team` on World
    // Cup entries).
    const useFlag = Flag && (team?.is_national_team || !team?.image);

    if (useFlag) {
        return <Flag title={team?.name} className={className} style={style} aria-label={alt ?? team?.name} />;
    }

    return (
        <img
            src={team?.image ?? ''}
            onError={(e) => { e.target.src = TeamIcon; }}
            className={className}
            style={style}
            alt={alt ?? team?.name}
        />
    );
};

export default TeamLogo;
